import { render, staticRenderFns } from "./SpecialOfferCreateButtonComponent.vue?vue&type=template&id=4154ead0&scoped=true"
import script from "./SpecialOfferCreateButtonComponent.vue?vue&type=script&lang=js"
export * from "./SpecialOfferCreateButtonComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4154ead0",
  null
  
)

export default component.exports